import { batch } from "react-redux";

export const calculateCashInHandForBatch = (meetings) => {
  let previousCashInHand = 0;

  const results = meetings.map((record) => {
    if (!record._id) {
      return false;
      }
       let error = { meetingDate: "", Reason: "" };
    const income = (
      (Number(record.batchSavingAmt) || 0) +
      (Number(record.batchSubAmt) || 0) +
      (Number(record.batchOtherContribution) || 0) +
      (Number(record.batchOtherIncome) || 0) +
      (Number(record.seedMoney) || 0) +
      (Number(record.subsidyReceived) || 0) +
      (Number(record.batchInterestPaid) || 0) + // This is income
      (Number(record.batchOtherLoanInterestShg) || 0) +
      (Number(record.batchLoanPaid) || 0) + // IL Repayment to SHG
      (Number(record.otherLoanPaidToShg) || 0) +
      (Number(record.sdUnionToSHG) || 0) 

    );

    const expense = (
      (Number(record.batchOtherLoanInterestDonor) || 0) +
      (Number(record.donationToOutsider) || 0) +
      (Number(record.travellingExpenses) || 0) +
      (Number(record.stationaryExpenses) || 0) +
      (Number(record.paidToMahasangha) || 0) +
      (Number(record.serviceCharges) || 0) +
      (Number(record.batchDividendDistributed) || 0) +
      (Number(record.otherExpenses) || 0) +
      (Number(record.batchSavingWithdrawals) || 0) +
      (Number(record.batchLoanAmt) || 0) + // Loan issued = Expense
      (Number(record.otherLoanPaidToDonor) || 0)
    );

  // Handle bankTransactions (add withdrawals to cash, subtract deposits from cash)
    const bankWithdrawals = (record.bankTransactions || []).reduce(
      (sum, tx) => sum + (Number(tx.indBatchBankWithdrawals) || 0),
      0
    );

    const bankDeposits = (record.bankTransactions || []).reduce(
      (sum, tx) => sum + (Number(tx.indBatchBankDeposit) || 0),
      0
    );

    const cashMovementFromBank = bankWithdrawals - bankDeposits;

    const currentCashInHand = previousCashInHand + income - expense + cashMovementFromBank;

    previousCashInHand = currentCashInHand;
    
      if (currentCashInHand !== record.cashInHand) {
          error.meetingDate = record._id;
          error.Reason = `Your meeting as on ${record._id} has error in cash in hand please submit the meeting`
      }
    

    return (currentCashInHand !== record.cashInHand) && (  {
      meetingDate: record._id,
      batchId: record.batchId,
      batchName: record.batchName,
      income,
      expense,
      calculatedCashInHand: currentCashInHand,
      originalCashInHand: record.cashInHand,
        bankTransactions: record.bankTransactions,
      errors: error,
      batchTransactionType: meetings[meetings.length - 1].batchTransactionType.batchTransactionType
    });
  });

  return results.filter(item => item !== false);
};

export const getOtherLoanOverPaidDetails = (meetings) => {
  let otherLoanTakenAmount = 0;
  let otherLoanPaid = 0;
  let overPaidDetails = [];

  meetings.forEach(element => {
    const taken = element.otherLoanSanctionedToMemberCash || 0;
    const paid = element.otherLoanPaidToDonor || 0;

    otherLoanTakenAmount += taken;
    otherLoanPaid += paid;

    if ((otherLoanPaid > otherLoanTakenAmount) &&  (element.batchId !== undefined)) {
      overPaidDetails.push({
        date: element._id,
        meetingDate: element._id,
        batchId: element.batchId,
        batchName: element.batchName,
        reason: 'Loan over paid',
        totalTaken: otherLoanTakenAmount,
        totalPaid: otherLoanPaid,
        overPaidAmount: otherLoanPaid - otherLoanTakenAmount,
         batchTransactionType: meetings[meetings.length - 1].batchTransactionType.batchTransactionType
      });
    }
  });

  return overPaidDetails;
};

